module.exports = __webpack_public_path__ + "static/Barcelona-42c2810ccfbb5b05492e4770175788ce.jpg";